import { render, staticRenderFns } from "./ProjectResultConfigItemModal.vue?vue&type=template&id=39378a81&scoped=true"
import script from "./ProjectResultConfigItemModal.vue?vue&type=script&lang=js"
export * from "./ProjectResultConfigItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39378a81",
  null
  
)

export default component.exports